import { getFile, postFile, putFile, destroyFile } from './base.js';

export const Files = {
  listAll: (submissionId) =>
    getFile(`/api/files/current-applicant/forms/${submissionId}/files`).then(
      ({ data }) => data
    ),
  get: (submissionId, id) =>
    getFile(`/api/files/current-applicant/forms/${submissionId}/files/${id}`).then(
      ({ data }) => data
    ),
  upload: (submissionId, documentType, formData, onUploadProgress) =>
    postFile(`/api/files/current-applicant/forms/${submissionId}/files/document-type/${documentType}`, formData, {
      onUploadProgress,
    }).then(({ data }) => data),
  download: (submissionId, id, filename) =>
    putFile(
      `/api/files/current-applicant/forms/${submissionId}/files/${id}/${encodeURIComponent(
        filename
      )}`
    ).then(({ data }) => data),
  destroy: (submissionId, id) =>
    destroyFile(`/api/files/current-applicant/forms/${submissionId}/files/${id}`).then(
      ({ data }) => data
    ),
};
